export const DEMO_ROUTE = '/demo';
export const MY_FOLDERS_ROUTE = '/mes-dossiers';